import type { IconSvgObject } from './types';

const CelsiusIcon: IconSvgObject = [
  ["path", { d: "M5 8C6.10457 8 7 7.10457 7 6C7 4.89543 6.10457 4 5 4C3.89543 4 3 4.89543 3 6C3 7.10457 3.89543 8 5 8Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 7C21 5.34315 19.6569 4 18 4H14C12.3431 4 11 5.34315 11 7V17C11 18.6569 12.3431 20 14 20H18C19.6569 20 21 18.6569 21 17", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default CelsiusIcon;
